<template>
  <span aria-hidden="true">
    <img
      v-if="url && !fallbackShown"
      class="favicon"
      :src="faviconUrl"
      alt=""
      @error="enableFallback"
    >
    <EIcon
      v-if="!url || fallbackShown"
      class="favicon__fallback"
      icon="atlas"
      size="s"
    />
  </span>
</template>

<script>
import EIcon from '~~/common/vue/components/icon';
import { isUrl } from '~~/common/js/universal/validators';

export default {
  name: 'EFavicon',
  components: {
    EIcon,
  },
  props: {
    url: {
      type: String,
      default: null,
      validator: isUrl,
    },
  },
  data: () => ({
    fallbackShown: false,
  }),
  computed: {
    domain() {
      const url = new URL(this.url);
      return url.hostname;
    },
    faviconUrl() {
      const faviconProxyUrl = `https://${this.$config.proxyHost}/favicon`;
      return `${faviconProxyUrl}?domain=${this.domain}&size=32`;
    },
  },
  methods: {
    enableFallback() {
      this.fallbackShown = true;
    },
  },
};
</script>

<style lang="scss">
.favicon {
  height: 16px;
  width: 16px;
}

.favicon__fallback {
  color: var(--color-decorative-icon);
}
</style>
